/**
 * This reducer is used for maintaining the state of the progress bar
 */
import {
    SET_PROGRESS_BAR_STATUS,
    SET_PROGRESS_BAR_CURRENT_STEP,
    RESET_PROGRESS_BAR_STATUS,
    SET_PROGRESS_BAR_EDIT_MODE,
} from '../action/types';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import i18n from 'src/i18n';

const progressBarInitialState = {
    Record: {
        label: 'Record',
        displayLabel: i18n.t('reportUsage.progressBar.recordTitle'),
        progress: 0,
        current: true,
        done: false,
    },
    Replen: {
        label: 'Replen',
        displayLabel: i18n.t('reportUsage.progressBar.replen'),
        progress: 50,
        current: false,
        done: false,
    },
    Procedure: {
        label: 'Procedure',
        displayLabel: i18n.t('reportUsage.progressBar.procedure'),
        progress: 0,
        current: false,
        done: false,
    },
    Submit: {
        label: 'Submit',
        displayLabel: i18n.t('reportUsage.progressBar.submit'),
        progress: 0,
        current: false,
        done: false,
    },
};

const updateProgressBarState = (state, completedStep) => {
    const newState = JSON.parse(JSON.stringify(state));
    if (!completedStep || !newState[completedStep]) {
        return newState;
    }
    const stepsLabels = Object.keys(newState);
    const indexOfCurrentStep = stepsLabels.findIndex(
        (stepLabel) => stepLabel === completedStep
    );
    if (indexOfCurrentStep === -1) {
        return newState;
    }
    if (newState[stepsLabels[indexOfCurrentStep + 1]]) {
        newState[stepsLabels[indexOfCurrentStep + 1]].progress = 100;
        if (newState[stepsLabels[indexOfCurrentStep + 2]])
            newState[stepsLabels[indexOfCurrentStep + 2]].progress = newState[
                stepsLabels[indexOfCurrentStep + 2]
            ].progress
                ? newState[stepsLabels[indexOfCurrentStep + 2]].progress
                : 50;
        newState[stepsLabels[indexOfCurrentStep + 1]].current = true;
        newState[stepsLabels[indexOfCurrentStep + 1]].done = newState[
            stepsLabels[indexOfCurrentStep + 1]
        ].done
            ? newState[stepsLabels[indexOfCurrentStep + 1]].done
            : false;
    }

    newState[completedStep].current = false;
    newState[completedStep].done = true;
    return newState;
};

const setProgressBarCurrentStep = (state, currentStep) => {
    const newState = JSON.parse(JSON.stringify(state));
    if (!currentStep || !newState[currentStep]) {
        return newState;
    }
    Object.keys(newState).forEach((step) => {
        if (step === currentStep) {
            newState[step].current = true;
        } else {
            newState[step].current = false;
        }
    });
    return newState;
};

const reportUsageProgressBarReducer = (
    state = progressBarInitialState,
    action = {}
) => {
    switch (action.type) {
        case SET_PROGRESS_BAR_STATUS:
            return {
                ...updateProgressBarState(state, action.payload),
            };
        case SET_PROGRESS_BAR_CURRENT_STEP:
            return {
                ...setProgressBarCurrentStep(state, action.payload),
            };
        case RESET_PROGRESS_BAR_STATUS:
            return {
                Record: {
                    label: 'Record',
                    displayLabel: i18n.t('reportUsage.progressBar.recordTitle'),
                    progress: 0,
                    current: true,
                    done: false,
                },
                Replen: {
                    label: 'Replen',
                    displayLabel: i18n.t('reportUsage.progressBar.replen'),
                    progress: 50,
                    current: false,
                    done: false,
                },
                Procedure: {
                    label: 'Procedure',
                    displayLabel: i18n.t('reportUsage.progressBar.procedure'),
                    progress: 0,
                    current: false,
                    done: false,
                },
                Submit: {
                    label: 'Submit',
                    displayLabel: i18n.t('reportUsage.progressBar.submit'),
                    progress: 0,
                    current: false,
                    done: false,
                },
            };
        case SET_PROGRESS_BAR_EDIT_MODE:
            return action.payload;
        default: {
            return { ...state };
        }
    }
};

// export default reportUsageProgressBarReducer;
export default persistReducer(
    {
        key: 'reportUsageProgressBarKey',
        storage: storage,
    },
    reportUsageProgressBarReducer
);
